import { machinesCatalog } from '@/app/utils/machines'
import styles from '@/styles/mobile/Home/MachineSection.module.scss'
import CustomLink from '../../UI/CustomLink'

export default function MachineSection() {
    return (
        <section className={styles.machineSection}>
            <h2 className={styles.machineSectionTitle}>
                Máquinas para o seu negócio
            </h2>
            <div className={styles.machineContainer}>
                {machinesCatalog.slice(0, 4).map((machine, index) => (
                    <div key={index} className={styles.machine}>
                        <div className={styles.machineImageContainer}>
                            <img
                                width={140}
                                height={140}
                                src={`https://gabcomercio.azureedge.net/azul-agro/general/machines/${machine
                                    .normalize('NFD')
                                    .replace(/[\u0300-\u036f]/g, '')
                                    .replace(/ç/g, 'c')
                                    .replace(/\s+/g, '-')
                                    .replace('.', '-')
                                    .toLowerCase()}.webp`}
                                alt={machine}
                            />
                            <h3 className={styles.machineName}>{machine}</h3>
                        </div>
                        <div className={styles.machineButtons}>
                            <CustomLink
                                href="/contato"
                                className="btn-primary-2"
                            >
                                faça uma cotação
                            </CustomLink>
                            <CustomLink
                                href={`/${machine
                                    .normalize('NFD')
                                    .replace(/[\u0300-\u036f]/g, '')
                                    .replace(/ç/g, 'c')
                                    .replace(/\s+/g, '-')
                                    .replace('.', '-')
                                    .toLowerCase()}`}
                                className="btn-secondary"
                            >
                                saiba mais
                            </CustomLink>
                        </div>
                    </div>
                ))}
            </div>
        </section>
    )
}
